import * as z from "zod";
import {RequestResModel} from "./RequestResModel";

const schema = z.object({
	content: z.array(RequestResModel.model).default([]),
	currentPage: z.number().default(0),
	pageSize: z.number().default(20),
	totalCount: z.number().default(0),
	totalPages: z.number().default(0)
});

const model = schema.transform((values) => ({
	...values
}));

export const TaxAccountantRequestSearchResModel = {schema, model};
export type ITaxAccountantRequestSearchResModel = z.infer<typeof TaxAccountantRequestSearchResModel.model>;
export const DEFAULT_TAX_ACCOUNTANT_REQUEST_SEARCH_RES: ITaxAccountantRequestSearchResModel = {
	content: [],
	currentPage: 0,
	pageSize: 20,
	totalCount: 0,
	totalPages: 0
};
